<template>
  <div>
    <Modal
      v-model="show"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="1200"
      @on-cancel="cancel"
    >
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" :label-width="155" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <Row :gutter="15" class="list">
              <TabPane :label="$t('Langue.zn')" name="1">
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem class="item_input" prop="zh-cn_title" :label="$t('title')">
                      <Input type="text" v-model="form['zh-cn_title']" placeholder="请输入标题"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="zh-cn_brief" :label="$t('brief')">
                      <Input type="text" v-model="form['zh-cn_brief']" placeholder="请输入简介"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="author" :label="$t('author')">
                      <Input type="text" v-model="form.author" placeholder="请输入作者"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="productId" :label="$t('product_ids')">
                      <Select v-model="form.productId" multiple placeholder="请选择">
                        <Scroll :on-reach-bottom="handleReachBottom2" height="200">
                          <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                          >{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                    <FormItem class="item_input" prop="thinkId" :label="$t('think_ids')">
                      <Select v-model="form.thinkId" multiple placeholder="请选择">
                        <Scroll :on-reach-bottom="handleReachBottom" height="200">
                          <Option
                            v-for="item in thinkList"
                            :value="item.think_id"
                            :key="item.think_id"
                          >{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem class="item_input" prop="video" :label="$t('videoURL')">
                      <Input type="text" v-model="form.video" placeholder="请输入youtube视频网址"></Input>
                    </FormItem>
                    <FormItem prop="sort_id" :label="$t('sort')">
                      <InputNumber
                        :min="1"
                        v-model="form.sort_id"
                        :placeholder="tabs == 1 ? '请输入排序顺序':tabs == 2 ? '請輸入排序順序':'Please enter the sort order'"
                      ></InputNumber>
                    </FormItem>
                    <FormItem :label="$t('onTop')" prop="top">
                      <i-Switch size="large" v-model="form.top" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('isHome')" prop="is_home">
                      <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('status')" prop="status">
                      <i-Switch
                        size="large"
                        v-model="form.status"
                        true-value="A2"
                        false-value="A1"
                      />
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24">
                  <FormItem prop="zh-cn_content" :label="$t('content')">
                    <vue-editor
                      v-model="form['zh-cn_content']"
                      placeholder="请输入内容"
                      :editor-toolbar="customToolbar"
                      :editorOptions="editorSettings"
                      :customModules="customModulesForEditor"
                      @image-added="handleImageAdded"
                      :useCustomImageHandler="true"
                    />
                  </FormItem>
                </Col>
              </TabPane>
              <TabPane :label="$t('Langue.tw')" name="2">
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem class="item_input" prop="zh-tw_title" :label="$t('title')">
                      <Input type="text" v-model="form['zh-tw_title']" placeholder="請輸入標題"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="zh-tw_brief" :label="$t('brief')">
                      <Input type="text" v-model="form['zh-tw_brief']" placeholder="請輸入簡介"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="author" :label="$t('author')">
                      <Input type="text" v-model="form.author" placeholder="請輸入作者"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="productId" :label="$t('product_ids')">
                      <Select v-model="form.productId" multiple placeholder="請選擇">
                        <Scroll :on-reach-bottom="handleReachBottom2" height="200">
                          <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                          >{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                    <FormItem class="item_input" prop="thinkId" :label="$t('think_ids')">
                      <Select v-model="form.thinkId" multiple placeholder="請選擇">
                        <Scroll :on-reach-bottom="handleReachBottom" height="200">
                          <Option
                            v-for="item in thinkList"
                            :value="item.think_id"
                            :key="item.think_id"
                          >{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem class="item_input" prop="video" :label="$t('videoURL')">
                      <Input type="text" v-model="form.video" placeholder="請輸入youtube視頻網址"></Input>
                    </FormItem>
                    <FormItem prop="sort_id" :label="$t('sort')">
                      <InputNumber
                        :min="1"
                        v-model="form.sort_id"
                        :placeholder="tabs == 1 ? '请输入排序顺序':tabs == 2 ? '請輸入排序順序':'Please enter the sort order'"
                      />
                    </FormItem>
                    <FormItem :label="$t('onTop')" prop="top">
                      <i-Switch size="large" v-model="form.top" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('isHome')" prop="is_home">
                      <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('status')" prop="status">
                      <i-Switch
                        size="large"
                        v-model="form.status"
                        true-value="A2"
                        false-value="A1"
                      />
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24">
                  <FormItem prop="zh-tw_content" :label="$t('content')">
                    <vue-editor
                      v-model="form['zh-tw_content']"
                      placeholder="請輸入內容"
                      :editor-toolbar="customToolbar"
                      :editorOptions="editorSettings"
                      :customModules="customModulesForEditor"
                      @image-added="handleImageAdded"
                      :useCustomImageHandler="true"
                    />
                  </FormItem>
                </Col>
              </TabPane>
              <TabPane :label="$t('Langue.en')" name="3">
                <Col span="24" style="display: flex;">
                  <Col span="12">
                    <FormItem class="item_input" prop="en_title" :label="$t('title')">
                      <Input type="text" v-model="form.en_title" placeholder="Please enter title"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="en_brief" :label="$t('brief')">
                      <Input
                        type="text"
                        v-model="form.en_brief"
                        placeholder="Please enter introduction"
                      ></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="author" :label="$t('author')">
                      <Input type="text" v-model="form.author" placeholder="Please enter author"></Input>
                    </FormItem>
                    <FormItem class="item_input" prop="productId" :label="$t('product_ids')">
                      <Select v-model="form.productId" multiple placeholder="Please Select">
                        <Scroll :on-reach-bottom="handleReachBottom2" height="200">
                          <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                          >{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                    <FormItem class="item_input" prop="thinkId" :label="$t('think_ids')">
                      <Select v-model="form.thinkId" multiple placeholder="Please Select">
                        <Scroll :on-reach-bottom="handleReachBottom" height="200">
                          <Option
                            v-for="item in thinkList"
                            :value="item.think_id"
                            :key="item.think_id"
                          >{{ item.title }}</Option>
                        </Scroll>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span="12">
                    <FormItem class="item_input" prop="video" :label="$t('videoURL')">
                      <Input
                        type="text"
                        v-model="form.video"
                        placeholder="Please enter YouTube video URL"
                      ></Input>
                    </FormItem>
                    <FormItem prop="sort_id" :label="$t('sort')">
                      <InputNumber
                        :min="1"
                        v-model="form.sort_id"
                        :placeholder="tabs == 1 ? '请输入排序顺序':tabs == 2 ? '請輸入排序順序':'Please enter the sort order'"
                      ></InputNumber>
                    </FormItem>
                    <FormItem :label="$t('onTop')" prop="top">
                      <i-Switch size="large" v-model="form.top" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('isHome')" prop="is_home">
                      <i-Switch size="large" v-model="form.is_home" true-value="1" false-value="0" />
                    </FormItem>
                    <FormItem :label="$t('status')" prop="status">
                      <i-Switch
                        size="large"
                        v-model="form.status"
                        true-value="A2"
                        false-value="A1"
                      />
                    </FormItem>
                  </Col>
                </Col>
                <Col span="24">
                  <FormItem prop="en_content" :label="$t('content')">
                    <vue-editor
                      v-model="form.en_content"
                      placeholder="Please enter the content"
                      :editor-toolbar="customToolbar"
                      :editorOptions="editorSettings"
                      :customModules="customModulesForEditor"
                      @image-added="handleImageAdded"
                      :useCustomImageHandler="true"
                    />
                  </FormItem>
                </Col>
              </TabPane>
            </Row>
          </Tabs>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { VueEditor, Quill } from 'vue2-editor'
// 导入图片操作相关插件
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
export default {
  components: {
    VueEditor
  },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String
  },
  data () {
    return {
      tabs: '1',
      form: {
        think_id: "",
        en_title: "",
        en_brief: "",
        en_content: "",
        "zh-cn_title": "",
        "zh-cn_brief": "",
        "zh-cn_content": "",
        "zh-cn_head_image": "",
        "zh-cn_mobile_head_image": "",
        "zh-tw_title": "",
        "zh-tw_brief": "",
        "zh-tw_content": "",
        video: "",
        status: "A1",
        is_home: "0",
        top: "0",
        product_ids: "",
        think_ids: "",
        productId: [],
        thinkId: [],
        sort_id: 1,
        author: '',
      },
      models: [],
      ruleInline: {
        author: [
          {
            required: true,
            message: this.$t("author_input"),
            trigger: "blur"
          }
        ],
        video: [
          {
            required: true,
            message: this.$t("video_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_title': [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_title': [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        en_title: [
          {
            required: true,
            message: this.$t("title_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_brief': [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_brief': [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        en_brief: [
          {
            required: true,
            message: this.$t("brief_input"),
            trigger: "blur"
          }
        ],
        'zh-cn_content': [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_content': [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        en_content: [
          {
            required: true,
            message: this.$t("content_input"),
            trigger: "blur"
          }
        ],
        productId: [
          { 
            //required: true, 
            type: 'array', min: 1, message: this.$t("product_ids_input"), trigger: 'change' },
        ],
        thinkId: [
          {
            //required: true,
            type: 'array', min: 1, message: this.$t("think_ids_input"), trigger: 'change'
          },
        ],
        status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        is_home: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        top: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        sort_id: [
          {
            type: 'number',
            required: true,
            message: this.$t('sort_input'),
            trigger: 'blur'
          }
        ],
      },
      customToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ 'align': ['', 'center', 'right', 'justify'] }],
        ['blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        ['link', 'clean'],
        ["image", "video"]                             // remove formatting button
      ],
      // 设置编辑器图片可拖拽
      editorSettings: {
        modules: { imageDrop: true, imageResize: {} }
      },
      customModulesForEditor: [
        { alias: "imageDrop", module: ImageDrop },
        { alias: "imageResize", module: ImageResize }
      ],
      show: this.modal,
      page: {
        limit: 20,
        page: 1,
        think_ids: ""
      },
      page2: {
        limit: 20,
        page: 1,
        product_ids: ""
      },
      thinkList: [],
      productList: [],
      total: 1,
      total2: 1,
    }

  },
  created () {
    this.info()

  },
  mounted () {

  },
  methods: {
    async info () {
      this.$base.showLoading();
      this.form.ad_id = this.$base.getRequest().id
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'think/before-upd',
          { think_id: this.itemObj.think_id },
          (success, data, error) => {
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info
            this.form.sort_id = data.info.sort_id * 1
            this.page2.product_ids = this.form.product_ids
            this.page.think_ids = this.form.think_ids
            let arr = [], arr2 = []
            arr = data.info.product_ids.split(',')
            arr2 = data.info.think_ids.split(',')
            arr.map(Number);
            arr2.map(Number);
            this.getDate(arr, arr2);
          }
        );
      } else {
        await this.getDate([], [])
      }
    },
    async getDate (arr, arr2) {
      this.$base.showLoading();
      await this.getthinkList().then((e) => {
        this.total = e.last_page
        this.thinkList = [...this.thinkList, ...e.list]
        if (arr2.length > 0) {
          this.form.thinkId = arr2
        }
      })
      await this.getProductList().then((e) => {
        this.total2 = e.last_page
        this.productList = [...this.productList, ...e.list]
        if (arr.length > 0) {
          this.form.productId = arr
        }
      })
      this.$base.hideLoading();
    },
    getthinkList () {
      return new Promise(resolve => {
        this.$request.sendPost(
          'think/list', this.page,
          (success, data, error) => {
            if (!success) resolve(this.$base.msgErr(error.errmsg));
            resolve(data);
          }
        );

      });
    },
    getProductList () {
      return new Promise(resolve => {
        this.$request.sendPost(
          'com/get-product-data', this.page2,
          (success, data, error) => {
            if (!success) resolve(this.$base.msgErr(error.errmsg));
            resolve(data);
          }
        );

      });
    },
    handleReachBottom2 () {
      return new Promise(resolve => {
        this.page2.page++
        if (this.page2.page > this.total2) resolve(this.$base.msgErr(this.$t('noMore')));
        this.getProductList().then((e) => {
          this.total2 = e.last_page
          this.productList = [...this.productList, ...e.list]
          resolve();
        })
      });
    },
    handleReachBottom () {
      return new Promise(resolve => {
        this.page.page++
        if (this.page.page > this.total) resolve(this.$base.msgErr(this.$t('noMore')));
        this.getthinkList().then((e) => {
          this.total = e.last_page
          this.thinkList = [...this.thinkList, ...e.list]
          resolve();
        })
      });
    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    // 自定义图片上传
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.$base.showLoading();
      this.$base.uploadPicimg(file, file.name).then(res => {
        this.$base.hideLoading();
        if (res.url) {
          Editor.insertEmbed(cursorLocation, "image", res.url);
          resetUploader();
        }
      });

    },
    submit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.form.product_ids = this.form.productId.join(',')
          this.form.think_ids = this.form.thinkId.join(',')
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'think/add' : 'think/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .list {
    width: 100%;
    padding: 30px;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .ivu-select-dropdown {
    overflow: overlay;
  }
  .demo-upload-list2 {
    width: 76px;
    height: 76px;
    position: relative;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;

    img {
      width: 76px;
      height: 76px;
      object-fit: cover;
      position: relative;
      // float: left;
      // border-radius: 50%;
    }

    .removeIcon {
      position: absolute;
      right: -7px;
      top: -7px;
      color: red;
      font-size: 16px;
      z-index: 8;
    }

    .eyeIcon {
      position: absolute;
      left: 50%;
      top: 50%;
      font-size: 30px;
      transform: translate(-50%, -50%);
      z-index: 7;
      font-weight: 550;
      display: none;
    }
  }

  .demo-upload-list2:hover {
    .eyeIcon {
      display: block;
    }
  }
  .demo-upload-list2 img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .demo-upload-list2:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover .iconeye {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
  .demo-upload-list-cover .icondel {
    position: absolute;
    top: -2px;
    right: -3px;
    color: #ff6262;
    font-size: 20px;
    cursor: pointer;
  }
  .demo-upload-list {
    display: inline-block;
    width: 300px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  // .ivu-upload-drag {
  //   height: 150px;
  // }
  .ivu-btn-small {
    height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 3px;
  }
  .ivu-tabs {
    overflow: inherit;
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .ql-editor {
    height: 500px;
  }
  .photo_tip {
    color: #c5c8ce;
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/think/module/think_edit.vue